export default "__VITE_ASSET__DTQYXYT7__"